<div class="btn-group">
	<app-dropdown-select
		[tooltip]="'Sort By'"
		[control]="control"
		[options]="sortByColumn$ | async"
		[label]="'Sort by'"
		dropdownMenuClass="checkbox-dropdown"
	></app-dropdown-select>
	<div class="col order-1 d-flex justify-content-end order-lg-4 col-lg-auto">
		<ng-container *ngIf="!!isSortAscControl">
			<button
				*ngIf="isSortAscControl.value"
				ngbTooltip="Sort Descending"
				(click)="isSortAscControl.setValue(false)"
				class="btn d-inline text-nowrap sort-btn"
			>
				↑↓
			</button>
			<button
				*ngIf="!isSortAscControl.value"
				ngbTooltip="Sort Ascending"
				(click)="isSortAscControl.setValue(true)"
				class="btn d-inline text-nowrap sort-btn"
			>
				↑↓
			</button>
		</ng-container>
	</div>
</div>
